import { render, staticRenderFns } from "./LevelsQuestion.vue?vue&type=template&id=6d253917"
import script from "./LevelsQuestion.vue?vue&type=script&lang=js"
export * from "./LevelsQuestion.vue?vue&type=script&lang=js"
import style0 from "./LevelsQuestion.vue?vue&type=style&index=0&id=6d253917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports